/**
 * Cât de mic poate fi un sportiv, în picker-e.
 *
 * Every form that asks for a child's age used to build its own list, and they
 * all started at six. The server accepted three, so the pickers were the real
 * limit — and a parent trying to enrol a three-year-old simply had no option
 * to choose, with nothing on screen explaining why. Clubs do run groups that
 * young: initiation, gymnastics, swimming, dance.
 *
 * One place now, matching MIN_ATHLETE_AGE in the backend's registrationRules.
 * If the two ever disagree, the form will offer something the server refuses,
 * which is exactly the bug this replaces — so they are kept in step by hand
 * and both are covered by tests.
 */

export const MIN_ATHLETE_AGE = 2;

/** The oldest someone can be and still be joining as an athlete. */
export const MAX_ATHLETE_AGE = 18;

/**
 * The oldest a *child* can be on a form a parent fills in for them. Eighteen
 * is an adult who signs up for themselves, so a parent's list stops at 17.
 */
export const MAX_CHILD_AGE = 17;

/** The whole list, inclusive at both ends. */
export function athleteAges(max: number = MAX_ATHLETE_AGE, min: number = MIN_ATHLETE_AGE): number[] {
  if (max < min) return [];
  return Array.from({ length: max - min + 1 }, (_, i) => min + i);
}

export function isValidAthleteAge(age: number, max: number = MAX_ATHLETE_AGE): boolean {
  return Number.isFinite(age) && age >= MIN_ATHLETE_AGE && age <= max;
}

/**
 * The U-N group an age belongs to.
 *
 * Mirrors `ageGroupFromAge` on the server, including U-6 for the youngest —
 * the group existed in the catalogue and nothing ever suggested it, so a
 * four-year-old was offered U-8 alongside the seven-year-olds.
 */
export function suggestAgeGroup(age: number | null): string | null {
  if (age === null || !Number.isFinite(age) || age <= 0) return null;
  if (age < 6) return "U-6";
  if (age < 8) return "U-8";
  if (age < 10) return "U-10";
  if (age < 12) return "U-12";
  if (age < 14) return "U-14";
  if (age < 16) return "U-16";
  if (age < 18) return "U-18";
  return "Seniori";
}
